import {
  useDocumentTitle,
  useDocumentTitles,
} from '@client-info/features/branding/hooks';
import { FullHeightPage } from '@client-info/features/shared/FullHeightPage';
import { HeaderWithPolicyTerms } from '@client-info/features/shared/HeaderWithPolicyTerms';
import { useVisibleViewportHeight } from '@components/utils';
import type { ReactNode } from 'react';
import { ChatContainer } from './styled';

interface Props {
  children: ReactNode;
}

export const GuestChatPageShell = ({ children }: Props) => {
  useDocumentTitle(useDocumentTitles().chat);
  const viewportHeight = useVisibleViewportHeight();

  return (
    <FullHeightPage sx={{ height: viewportHeight, minHeight: 0 }}>
      <HeaderWithPolicyTerms showLinks={false} />
      <ChatContainer>{children}</ChatContainer>
    </FullHeightPage>
  );
};
